import { Link } from "react-router-dom";

const CHANNELS = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tvseries" },
  { label: "影视专题", to: "/specials" },
];

const HELP = [
  { label: "搜索影视", to: "/search" },
  { label: "关于我们", to: "/about" },
  { label: "意见反馈", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
              <i className="ri-film-line" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              韩国伦理在线观看
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            专注韩国伦理题材电影与电视剧的作品展示与浏览，收录丰富的伦理剧情内容，帮助你快速发现值得一看的伦理影视作品。
          </p>
          <p className="mt-4 flex items-center gap-2 text-xs text-background-400">
            <i className="ri-information-line text-base" />
            本站仅提供作品信息与封面展示，不提供在线播放或下载服务。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
            内容频道
          </h4>
          <ul className="mt-4 space-y-2.5">
            {CHANNELS.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
            帮助与支持
          </h4>
          <ul className="mt-4 space-y-2.5">
            {HELP.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-center gap-2 text-sm text-background-300">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-800 text-base">
              <i className="ri-mail-line" />
            </span>
            contact@kr-eth-drama.demo
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-8">
          <p>© {new Date().getFullYear()} 韩国伦理在线观看 · 仅供演示学习使用</p>
          <p>本站内容为演示数据，请遵守当地法律法规，理性观影</p>
        </div>
      </div>
    </footer>
  );
}